<form [formGroup]="billingFreeForm" (ngSubmit)="onSubmit()" class="mat-card-billing-free">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'billing.billing-free-creation' | translate }}</mat-card-title>
      <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
    </mat-card-header>
    <mat-card-content>

      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('billingTypeId')">*</span>{{ 'label.type' | translate
          }}</label>
        <mat-radio-group aria-label="Select an option" formControlName="billingTypeId" class="content-row-input">
          <mat-radio-button value="4">{{ 'label.free-billing' | translate}}</mat-radio-button>
          <mat-radio-button value="5">{{ 'label.credit-note' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('company')">*</span>{{ 'label.company' | translate
          }}</label>
        <app-company-list [control]="$any(billingFreeForm).controls['company']" class="content-row-input">
        </app-company-list>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('site')">*</span>{{ 'label.site' | translate }}</label>
        <app-site-list [control]="$any(billingFreeForm).controls['site']" class="content-row-input" [pacoOnly]="true">
        </app-site-list>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('date')">*</span>{{ 'label.date' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="date" formControlName="date" autocomplete="off" [min]="uiService.getMinDate()"
            [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
          <mat-datepicker #date [disabled]="billingFreeForm.get('date')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('tva')">*</span>{{ 'label.tva' | translate }}
        </label>

        <mat-form-field class="content-row-input">
          <input matInput formControlName="tva" type="number" max="100" min="0" step="0.01" autocomplete="off">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
      <div class="comment-row">
        <div style="display: flex;
      justify-content: space-between;
      padding: 10px 0 15px 10px;">
          <label>
            <span class="required-asterisk">*</span>{{ 'billing.item-title' | translate }}
          </label>

          <button mat-mini-fab style="margin-right: 10px;" (click)="onAddItem()" type="button">
            <mat-icon>add</mat-icon>
          </button>
        </div>


        <table mat-table [dataSource]="dataSource" matSort style="width: 100%; margin-bottom: 15px;">
          <!-- name Column -->
          <ng-container matColumnDef="name">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.name' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.name }}</span>
            </td>
          </ng-container>

          <!-- value Column -->
          <ng-container matColumnDef="value">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.quantity' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.value | number :'0.0' :'fr'}}</span>
            </td>
          </ng-container>

          <!-- tva Column -->
          <ng-container matColumnDef="tva">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.tva' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.tva }} %</span>
            </td>
          </ng-container>

          <!-- priceHtva Column -->
          <ng-container matColumnDef="priceHtva">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.unitPriceHtva' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.priceHtva | number :'0.2' :'fr'}}</span>
            </td>
          </ng-container>

          <!-- priceTva Column -->
          <ng-container matColumnDef="priceTva">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.unitPriceTva' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.priceTva | number :'0.2' :'fr'}}</span>
            </td>
          </ng-container>

          <!-- totalHtva Column -->
          <ng-container matColumnDef="totalHtva">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.totalHtva' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.totalHtva | number :'0.2' :'fr'}}</span>
            </td>
          </ng-container>

          <!-- totalTva Column -->
          <ng-container matColumnDef="totalTva">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header>{{ 'label.totalTva' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span> {{ element?.totalTva | number :'0.2' :'fr'}}</span>
            </td>
          </ng-container>

          <!-- remove Column -->
          <ng-container matColumnDef="remove">
            <th class="header" mat-header-cell *matHeaderCellDef>
              <div mat-sort-header></div>
            </th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab color="primary" type="button" (click)="onRemoveItem(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
        </table>

      </div>

      <div class="comment-row">
        <mat-form-field style="width: 100%;">
          <textarea rows="10" formControlName="comment" matInput style="width: 100%;"
            placeholder="{{ 'label.comment' | translate}}"></textarea>
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-actions class="billing-free-card-action">
      <button mat-raised-button color="primary" [disabled]="billingFreeForm.invalid || dataSource.data.length == 0">
        <mat-icon>add</mat-icon> {{ 'button.create-free-billing' | translate }}
      </button>
      <!-- <button mat-raised-button color="primary" [disabled]="billingFreeForm.invalid" (click)="onCreateCreditNote()">
      <mat-icon>add</mat-icon> {{ 'button.create-credit-note' | translate }}
    </button> -->
    </mat-card-actions>
  </mat-card>
</form>